module.exports = __webpack_public_path__ + "static/media/rooftype-residential.fc5b644f.png";